import { render, staticRenderFns } from "./LCascader.vue?vue&type=template&id=07cfd188&scoped=true"
import script from "./LCascader.vue?vue&type=script&lang=js"
export * from "./LCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cfd188",
  null
  
)

export default component.exports